<template>
    <q-page class="q-pa-md">
        <three_pl_serial_numbers ref="three_pl_serial_numbers"></three_pl_serial_numbers>
    </q-page>
</template>

<script>
    export { default } from './threeplserialnumbersapplicationviewmodel-custom-screen.js'
</script>